// mydatafeed/services/realtime_price_feed.js
import {
    socketPF,
    connectWebSocketPF,
    closeWebSocketPF
} from "../websocket_price_feed.js";

/** Garantiza que haya socket en modo realtime para Price Feed. */
export function ensureRealtimeSocketPF() {
    if (socketPF) return;
    connectWebSocketPF();
}

/** Cierra WS si no hay suscriptores activos en Price Feed. */
export function closeRealtimeIfIdlePF(noSubscribers) {
    if (noSubscribers && socketPF) {
        closeWebSocketPF();
    }
}
